import { cn } from 'design-system'
import { Ban, CircleAlert, CircleCheckBig, Info } from 'lucide-react'
import React, { FC, PropsWithChildren } from 'react'

export const types = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
} as const

const icons = {
  info: Info,
  success: CircleCheckBig,
  warning: CircleAlert,
  error: Ban
}

const TYPE_LABELS: Record<(typeof types)[keyof typeof types], string> = {
  warning: 'Warning',
  error: 'Error',
  success: 'Success',
  info: 'Information'
}

interface CalloutProps {
  type?: (typeof types)[keyof typeof types]
  className?: string
  id?: string
}

const Callout: FC<PropsWithChildren<CalloutProps>> = ({
  type = 'info',
  className,
  children,
  id
}) => {
  const Icon = icons[type]

  return (
    <div
      {...(id ? { id } : null)}
      className={cn(
        'text-light flex items-center gap-x-2 border-l-2 border-solid border-current py-2 pl-2 pr-4',
        {
          'bg-yellow-50 text-yellow-500': type === 'warning',
          'bg-red-50 text-red-600': type === 'error',
          'bg-green-50 text-green-400': type === 'success',
          'bg-blue-50 text-blue-600': type === 'info'
        },
        className
      )}>
      {Icon ? (
        <Icon
          size={18}
          className="shrink-0"
          role="img"
          aria-label={TYPE_LABELS[type]}
        />
      ) : null}
      <div className="grow text-slate-950">{children}</div>
    </div>
  )
}

export default Callout
